import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {ToastrService} from "ngx-toastr";


@Component({
  selector: 'app-note-modal',
  templateUrl: './note-modal.component.html',
  styleUrls: ['./note-modal.component.scss']

})
export class NoteModalComponent implements OnInit {
    hasPrecedente = true;
    tipoNote:string;
    tipoNotePrecedente:string = ""
    notePrecedenti = ""
    note:string = "";

    constructor(
        private activeModal:NgbActiveModal,
        private toastrService:ToastrService
    ){

    }

    save(){
        /*if(this.note.length == 0)
        {
            this.toastrService.error("Il Campo Note è Richiesto")
            return 
        }else{*/
            this.toastrService.success("Cambiamento effettuato con successo")
            this.activeModal.close(this.note);
        //}

    }

    closeModal(){
        this.activeModal.dismiss()
    }

    ngOnInit(){

    }



}
